import {
  createLoader,
  createParser,
  createSerializer,
  parseAsString,
} from "nuqs/server";
import { kioskStageMode, type KioskStageMode } from "../kiosk";

const watchSearchParams = {
  e: parseAsString,
  league: createParser({
    parse: (value) => (value === "" ? null : value),
    serialize: (value: string) => value,
  }),
  view: parseAsString,
  version: parseAsString,
  kiosk: createParser({
    parse: kioskStageMode,
    serialize: (mode: KioskStageMode) => mode,
  }),
};

export const readWatchSearch = createLoader(watchSearchParams);
export const writeWatchSearch = createSerializer(watchSearchParams);
